import Component from '@glimmer/component';
import EmberPopover from '@mylighthouse/prism-ember/components/ember-popover';

import styles from './override-cell-popover.module.css';

interface HotelPricingAssistantTablePopoversOverrideCellPopoverSignature {
  Args: {
    dataTestId?: string;
    isShown: boolean;
    onClose?: () => void;
  };
  Blocks: {
    default: [];
  };
}

/*
 * No @popperContainer is passed, so EmberPopover defaults to <body>. Previously it pointed at
 * the price cell, which meant the popover got clipped by the table's overflow container on the
 * last row — there's nothing below it to scroll to. Rendering in <body> escapes that overflow context entirely.
 */
export default class HotelPricingAssistantTablePopoversOverrideCellPopover extends Component<HotelPricingAssistantTablePopoversOverrideCellPopoverSignature> {
  popperOptions = {
    modifiers: {
      arrow: {
        enabled: false,
      },
      matchWidth: {
        enabled: true,
        /*
         * Must run before applyStyle (order 900), which flushes data.styles to the DOM.
         * Without an explicit order the modifier position is non-deterministic and the
         * width may never be written.
         */
        order: 840,
        fn(data: {
          offsets: { reference: { width: number } };
          styles: Record<string, string>;
        }): {
          offsets: { reference: { width: number } };
          styles: Record<string, string>;
        } {
          /*
           * Override the popover's width to match the price cell.
           * Without this, width: 100% in the CSS resolves to the viewport width
           * because the popover is appended to <body>.
           */
          data.styles['width'] = `${data.offsets.reference.width}px`;
          return data;
        },
      },
    },
  };

  <template>
    <EmberPopover
      @animationDuration={{0}}
      @delay={{0}}
      @event="none"
      @hideOn="click"
      @isShown={{@isShown}}
      @popoverHideDelay={{0}}
      @popperOptions={{this.popperOptions}}
      @side="bottom"
      {{! spacing matches .price-cell height (48px) - height difference between the value container and the cell content (4px) }}
      @spacing={{-44}}
      @tooltipClass="base-tooltip {{styles.container}}"
    >
      <div data-test-id={{@dataTestId}}>
        {{yield}}
      </div>
    </EmberPopover>
  </template>
}
